// @ts-nocheck FIXME
import { useLegacyLabContext } from '@contexts/LegacyLabContext';
import Utils from '@legacy-components/components/DynamicUtils';
import NavigationLink from '@legacy-components/react/NavigationLink';
import Dropdown from './Dropdown';
import React from 'react';

const Links = (): React.ReactElement => {
  const lab = useLegacyLabContext();
  const isFreeUser = !Utils.hasAnyProductRole?.call(lab, lab?.pageData?.user);

  // Filter out Instructional Strategies for free users
  const navOptions = [
    {
      caption: 'Student-Centered Learning',
      link: `${process.env.REACT_APP_MARKETING_URL}/learning-experiences/student-centered-teaching?from=header_link`,
      external: true,
    },
    {
      caption: 'Our Content Partners',
      link: `${process.env.REACT_APP_TEACHING_URL}/browse/content-partners?from=header_link`,
      external: true,
    },
  ];

  if (!isFreeUser) {
    navOptions.push({
      caption: 'Instructional Strategies',
      link: `${process.env.REACT_APP_TEACHING_URL}/browse/strategies?from=header_link`,
      external: true,
    });
  }

  navOptions.push({
    caption: 'Lesson Plans',
    link: `${process.env.REACT_APP_TEACHING_URL}/browse/master_teachers/projects?from=header_link`,
    external: true,
  });

  const ResourcesLink = (
    <Dropdown navKey={'resources'} navOptions={navOptions}>
      <div className="header__dropdown-handle">Instructional Resources</div>
    </Dropdown>
  );

  const generatedHomeLink = Utils.redirectToHomeBasedOnProductRoles.call(lab);
  const labHomeLinkNode = (
    <NavigationLink className="header__link tc__link" url={generatedHomeLink}>
      BL Lab Home
    </NavigationLink>
  );

  return (
    <nav className="header__link-container">
      {labHomeLinkNode}
      {ResourcesLink}
    </nav>
  );
};

export default Links;
